import { useMemo } from 'react'
import { ChallengeService } from '@duck/api-definitions'
import { workspaceTabsDefinitions } from '@/components/WorkspaceTabs/workspaceTabs.definitions'
import { useCanUsePython } from './useCanUsePython'

export const useAvailableWorkspaceTabs = (): Set<ChallengeService.WorkspaceTabTypeEnum> => {
  const canUsePython = useCanUsePython()
  return useMemo(() => {
    const allowed = new Set<ChallengeService.WorkspaceTabTypeEnum>()
    for (const key of Object.keys(workspaceTabsDefinitions)) {
      const type = key as ChallengeService.WorkspaceTabTypeEnum
      if (type === ChallengeService.WorkspaceTabTypeEnum.Python && !canUsePython) continue
      allowed.add(type)
    }
    return allowed
  }, [canUsePython])
}
